import { Stack, StackProps, Typography } from '@mui/material'
import { KIconButton } from 'components/core/KButton'
import RemoveIcon from '@mui/icons-material/Remove'
import AddIcon from '@mui/icons-material/Add'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { MouseEventHandler } from 'react'

interface OrderItemQuantityProps extends StackProps {
  increaseQuantity?: MouseEventHandler<HTMLButtonElement>
  decreaseQuantity?: MouseEventHandler<HTMLButtonElement>
  quantity?: number
  allowDelete?: boolean
  readonly?: boolean
}

export const OrderItemQuantity = ({
  increaseQuantity,
  decreaseQuantity,
  quantity,
  allowDelete,
  readonly,
  ...props
}: OrderItemQuantityProps) => {
  return (
    <Stack {...props} direction="row" alignItems="center" spacing={2}>
      {!readonly && (
        <KIconButton onClick={decreaseQuantity}>
          {allowDelete && quantity === 1 ? (
            <DeleteOutlineIcon />
          ) : (
            <RemoveIcon />
          )}
        </KIconButton>
      )}
      <Typography variant="h4">
        {readonly && 'x '}
        {quantity ?? 0}
      </Typography>
      {!readonly && (
        <KIconButton onClick={increaseQuantity}>
          <AddIcon />
        </KIconButton>
      )}
    </Stack>
  )
}
